import type { TOC } from '@ember/component/template-only';
import WrDetails from 'ember-wiser/components/details';
import WrForm from 'ember-wiser/components/form';
import FileAttachementRow from 'parog-web/components/dialysis/edition-form/file-attachement-row';
import type HemodialysisMeasuredJournalEvent from 'parog-web/models/hemodialysis-measured-journal-event';
import type TypedEmberChangeset from 'parog-web/utils/typed-ember-changeset';

interface Signature {
  Args: {
    measurement: TypedEmberChangeset<HemodialysisMeasuredJournalEvent>;
    onSubmit: () => void;
  };
}

const HemodialysisSessionEditionFormStartSessionEditionFormComponent: TOC<Signature> =
  <template>
    <WrDetails @summary='Mesure 1' class='mt-2'>

      <WrForm @data={{@measurement}} @onSubmit={{@onSubmit}} as |form|>
        <form.InputRow
          @name='occurredAt'
          @label='Date de la séance *'
          type='datetime-local'
          class='[&+span]:mt-2 [&+span]:block [&+span]:leading-[1.094rem]'
        >&nbsp;
        </form.InputRow>

        <form.InputRow
          @label='Poids sec'
          @name='startDryWeight'
          min='0'
          type='number'
          class='mb-2 sm:mb-0'
          placeholder='Ex: 80'
        >kg</form.InputRow>

        <form.InputRow
          @label='Poids réel'
          @name='startRealWeight'
          min='0'
          type='number'
          class='mb-2 sm:mb-0'
          placeholder='Ex: 80'
        >kg</form.InputRow>

        <form.InputRow
          @label='Pression artérielle systolique'
          @name='startArterialSystolicPressure'
          min='0'
          type='number'
          class='mb-2 sm:mb-0'
          placeholder='Ex: 120'
        >mmHg</form.InputRow>

        <form.InputRow
          @label='Pression artérielle diastolique'
          @name='startArterialDiastolicPressure'
          min='0'
          type='number'
          class='mb-2 sm:mb-0'
          placeholder='Ex: 75'
        >mmHg</form.InputRow>

        <form.InputRow
          @label='Fréquence cardiaque'
          @name='startHeartRate'
          min='0'
          type='number'
          class='mb-2 sm:mb-0'
          placeholder='Ex: 70'
        >bpm</form.InputRow>

        <form.InputRow
          @label='UF totale à réaliser'
          @name='startUltrafiltrationTotal'
          min='0'
          type='number'
          class='mb-2 sm:mb-0'
          placeholder='Ex: 2000'
        >mL</form.InputRow>

        <FileAttachementRow
          @form={{form}}
          @title='Prendre une photo de la machine'
        />

        <form.TextareaRow
          @label='Commentaires patient'
          @name='comments'
          class='mt-2 sm:mt-0'
          placeholder='Laisser un commentaire…'
        >
          &nbsp;
        </form.TextareaRow>

        {{! Hack: add a hidden native submit button so that
          pressing "Enter" triggers a proper HTML form submission. }}
        <button type='submit' class='hidden'></button>

      </WrForm>

    </WrDetails>
  </template>;

export default HemodialysisSessionEditionFormStartSessionEditionFormComponent;
